import { Index, useHits } from "react-instantsearch";

import { AlgoliaFinishHit } from "../../types/AlgoliaTypes";
import { useLocation, useNavigate } from "react-router-dom";
import { ReactNode, useEffect, useRef } from "react";
import { PLACEHOLDER_IMAGE } from "../../data/constants";
import { algoliaConfig } from "../../data/config";
import SteelcaseImage from "../layout/SteelcaseImage/SteelcaseImage";

interface PanelHitsProps {
    isClosed: boolean;
    setIsClosed: React.Dispatch<React.SetStateAction<boolean>>
    query?: string;
    children?: ReactNode;
}

export default function PanelHits({ isClosed, setIsClosed, query, children }: PanelHitsProps) {

    const { hits, results } = useHits<AlgoliaFinishHit>();
    const dropdownRef = useRef<HTMLDivElement | null>(null);
    const navigate = useNavigate();
    const location = useLocation();
    
    const handleClickOutside = (event: MouseEvent) => {
        if(dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
            setIsClosed(true);
        }
    }

    useEffect(() => {
        document.addEventListener('click', handleClickOutside);
        return () => {
            document.removeEventListener('click', handleClickOutside);
        }
    }, [])
    
    return (
        <div 
            className={[
                isClosed && 'finish-search-box__panel--hide',
                'finish-search-box__panel',
            ]
            .filter(Boolean)
            .join(' ')}
            ref={dropdownRef}
        >
            <div className={"finish-search-box__panel-layout finish-search-box__panel--scrollable"}>
                <section className={"source-results"}>
                    <ul className={"finish-search-box__results"}>
                        {
                            results && hits.length > 0 ?
                                results && (location.pathname.includes("products") || location.pathname.includes("produkte") || location.pathname.includes("produits") || location.pathname.includes("productos")) ?
                                    <li className={"finish-search-box__item"}>
                                        <a href={`https://${window.steelcase_finish_library.siteUrl.host}${window.steelcase_finish_library.siteUrl.path}finishes/search?query=${query}&initialClose=true`} target="_blank" rel="noopener noreferrer" style={{ textDecoration: "none" }}>
                                            <div className="finish-search-box__all-results-title">
                                                <strong>{`${window.steelcase_i18n["steelcase-finish-library"].results_start ? window.steelcase_i18n["steelcase-finish-library"].results_start : "See all"} ${results.nbHits} ${window.steelcase_i18n["steelcase-finish-library"].results_end ? window.steelcase_i18n["steelcase-finish-library"].results_end : "results."}`}</strong>

                                            </div>
                                        </a>
                                    </li>
                                :
                                    <li className={"finish-search-box__item"} onClick={() => navigate(`/finishes/search?query=${query}&initialClose=true`)}>
                                        <div className="finish-search-box__all-results-title">
                                            <strong>{`${window.steelcase_i18n["steelcase-finish-library"].results_start ? window.steelcase_i18n["steelcase-finish-library"].results_start : "See all"} ${results.nbHits} ${window.steelcase_i18n["steelcase-finish-library"].results_end ? window.steelcase_i18n["steelcase-finish-library"].results_end : "results."}`}</strong>
                                        </div>
                                    </li>
                            :
                                <>
                                    {
                                        results && (location.pathname.includes("products") || location.pathname.includes("produkte") || location.pathname.includes("produits") || location.pathname.includes("productos")) ?
                                            <li className={"finish-search-box__item"}>
                                                <a href={`https://${window.steelcase_finish_library.siteUrl.host}${window.steelcase_finish_library.siteUrl.path}finishes/search?query=${query}&initialClose=true`} target="_blank" rel="noopener noreferrer" style={{ textDecoration: "none" }}>
                                                    <div className="finish-search-box__all-results-title">
                                                        <strong>{window.steelcase_i18n["steelcase-finish-library"].all_results || "See all results."}</strong>
                                                    </div>
                                                </a>
                                            </li>
                                            :
                                            <li className={"finish-search-box__item"} onClick={() => navigate(`/finishes/search?query=${query}&initialClose=true`)}>
                                                <div className="finish-search-box__all-results-title">
                                                    <strong>{window.steelcase_i18n["steelcase-finish-library"].all_results || "See all results."}</strong>
                                                </div>
                                            </li>
                                    }
                                    
                                    <li className={"finish-search-box__item"}>
                                        <div className="finish-search-box__item-title">
                                            {window.steelcase_i18n["steelcase-finish-library"].no_result || "We coulnd't find any matching materials. Try 'See all results' to explore more."}
                                        </div>
                                    </li>
                                </>
                                
                        }
                        
                        {
                            hits.slice(0, 3).map((hit) => {
                                return (
                                    <li 
                                        key={hit.objectID}
                                        className={"finish-search-box__item"}
                                    >
                                        <PanelHit algoliaFinishHit={hit} setIsClosed={setIsClosed} />
                                    </li>
                                )
                            })
                        }
                         
                        {children && children}
                    </ul>
                </section>
            </div>
        </div>
    );
}

interface PanelHitProps {
    algoliaFinishHit: AlgoliaFinishHit
    setIsClosed: React.Dispatch<React.SetStateAction<boolean>> 
}

function PanelHit({ algoliaFinishHit, setIsClosed }: PanelHitProps) {
    // const supplier = filters.supplier ? filters.supplier[0] : brandNames[0];

    const navigate = useNavigate();
    const location = useLocation();

    const handleResultClick = () => {
        setIsClosed(true)
        navigate(`/finish/${algoliaFinishHit.routerValue ? algoliaFinishHit.routerValue : algoliaFinishHit.objectID}`);
    }
    
    return (
        location.pathname.includes("products") || location.pathname.includes("produkte") || location.pathname.includes("produits") || location.pathname.includes("productos") ? 
            <a href={`https://${window.steelcase_finish_library.siteUrl.host}${window.steelcase_finish_library.siteUrl.path}finish/${algoliaFinishHit.routerValue ? algoliaFinishHit.routerValue : algoliaFinishHit.objectID}`} target="_blank" rel="noopener noreferrer" style={{ textDecoration: "none" }}>
                <div className="finish-search-box__item--flex">
                    <SteelcaseImage
                        className={"finish-search-box__item-img"}
                        src={algoliaFinishHit.swatch ? algoliaFinishHit.swatch.fileURL 
                            : PLACEHOLDER_IMAGE}
                        altText={algoliaFinishHit.swatch && algoliaFinishHit.swatch.fileName ? algoliaFinishHit.swatch.fileName: ""}
                        width="40"
                        height="40"
                    />
                    <div className="finish-search-box__item-content">
                        <div className="finish-search-box__item-title finish-search-box__primary">
                            {algoliaFinishHit.parentFabricFamily && algoliaFinishHit.parentFabricFamily.familyName !== null && algoliaFinishHit.parentFabricFamily.familyName !== undefined 
                                ? `${algoliaFinishHit.parentFabricFamily?.familyName ?? ""} ${algoliaFinishHit.finishName} ` 
                                : `${algoliaFinishHit.finishCode} ${algoliaFinishHit.finishName ? algoliaFinishHit.finishName : ""}`}
                        </div>
                        <div className="finish-search-box__item-description">
                            {algoliaFinishHit.subcategory?.label} | {algoliaFinishHit.finishCode}
                        </div>
                    </div>
                </div>
            </a>
        :
            <div className="finish-search-box__item--flex" onClick={handleResultClick}>
                <SteelcaseImage
                    className={"finish-search-box__item-img"}
                    src={algoliaFinishHit.swatch ? algoliaFinishHit.swatch.fileURL 
                        : PLACEHOLDER_IMAGE}
                    altText={algoliaFinishHit.swatch && algoliaFinishHit.swatch.fileName ? algoliaFinishHit.swatch.fileName: ""}
                    width="40"
                    height="40"
                    deliveryOptions={{seoFileName: algoliaFinishHit?.finishName, format: "webp", width: "1000", height: "1000", quality: "60", crop: {cropType: "absolute", cropValues: "500,500,500,500"}}}
                />
                <div className="finish-search-box__item-content">
                    <div className="finish-search-box__item-title finish-search-box__primary">
                        {algoliaFinishHit.parentFabricFamily && algoliaFinishHit.parentFabricFamily.familyName !== null && algoliaFinishHit.parentFabricFamily.familyName !== undefined 
                            ? `${algoliaFinishHit.parentFabricFamily?.familyName ?? ""} ${algoliaFinishHit.finishName} ` 
                            : `${algoliaFinishHit.finishCode} ${algoliaFinishHit.finishName ? algoliaFinishHit.finishName : ""}`}
                    </div>
                    <div className="finish-search-box__item-description">
                        {algoliaFinishHit.subcategory?.label} | {algoliaFinishHit.finishCode}
                    </div>
                </div>
            </div>
    )
}